import { defineStore } from 'pinia'
import { getContentPage } from '@/services/contentService'

export const useAboutContentStore = defineStore('about', {
  state: () => ({
    contents: {
      about: {},
      focus: {},
      who: {},
      ourHistory: {},
      ourCommitment: {},
      leadership: {},
      leaderships: [],
      ourMission: {},
      safety: {},
      ourPurpose: {},
      ourPosition: {},
    },
    loading: false,
    error: null
  }),

  actions: {
    async fetchAboutPage() {
      this.loading = true
      this.error = null

      try {
        const baseUploadURL = process.env.VUE_APP_API_URL;
        const aboutContent = await getContentPage('About Us', 'About Us')
        const focusContent = await getContentPage('About Us', 'Our Focus')
        const whoContent = await getContentPage('About Us', 'Who We Are')
        const ourHistoryContent = await getContentPage('About Us', 'Our History')
        const ourCommitmentContent = await getContentPage('About Us', 'Our Commitment To Community')
        const leadershipContent = await getContentPage('About Us', 'Leadership')
        const leadershipList = await getContentPage('Home', 'Item Leadership')
        const ourMissionContent = await getContentPage('About Us', 'Our Mission')
        const safetyContent = await getContentPage('About Us', 'Safety')
        const ourPurposeContent = await getContentPage('About Us', 'Our Purpose')
        const ourPositionContent = await getContentPage('About Us', 'Our Position')

        const mapAboutContent = await Promise.all(
          aboutContent.map(async item => ({
            ...item,
            image: item.banner
              ? baseUploadURL + item.banner.uploadFile
              : null,
          }))
        )

        const mapWhoContent = await Promise.all(
          whoContent.map(async item => ({
            ...item,
            image: item.banner
              ? baseUploadURL + item.banner.uploadFile
              : null,
          }))
        )

        const mapOurHistoryContent = await Promise.all(
          ourHistoryContent.map(async item => ({
            ...item,
            image: item.banner
              ? baseUploadURL + item.banner.uploadFile
              : null,
          }))
        )

        const mapOurCommitmentContent = await Promise.all(
          ourCommitmentContent.map(async item => ({
            ...item,
            image: item.banner
              ? baseUploadURL + item.banner.uploadFile
              : null,
          }))
        )

        const mapLeadershipList = await Promise.all(
          leadershipList.map(async item => ({
            ...item,
            image: item.banner
              ? baseUploadURL + item.banner.uploadFile
              : null,
          }))
        )

        this.contents.about = mapAboutContent[0]
        this.contents.focus = focusContent[0]
        this.contents.who = mapWhoContent[0]
        this.contents.ourHistory = mapOurHistoryContent[0]
        this.contents.ourCommitment = mapOurCommitmentContent[0]
        this.contents.leadership = leadershipContent[0]
        this.contents.leaderships = mapLeadershipList
        this.contents.ourMission = ourMissionContent[0]
        this.contents.safety = safetyContent[0]
        this.contents.ourPurpose = ourPurposeContent[0]
        this.contents.ourPosition = ourPositionContent[0]

        // console.log(this.contents.about)
        // console.log(this.contents.focus)
        // console.log(this.contents.who)
        // console.log(this.contents.ourHistory)
        // console.log(this.contents.ourCommitment)
        // console.log(this.contents.leadership)
        // console.log(this.contents.leaderships)
        // console.log(this.contents.ourMission)
        // console.log(this.contents.safety)
        // console.log(this.contents.ourPurpose)
        // console.log(this.contents.ourPosition)
      } catch (err) {
        this.error = err.message
      } finally {
        this.loading = false
      }
    }
  }
})